import { cnx as cnxColors, pv as pvColors } from "./tokens/colors";
import * as border from "./tokens/border";
import * as grid from "./tokens/grid";
import * as shadow from "./tokens/shadow";
import * as spacing from "./tokens/spacing";
import * as typography from "./tokens/typography";

export const cnxTokens = {
  colors: cnxColors,
  border,
  grid,
  shadow,
  spacing,
  typography: typography.typography,
};

export const pvTokens = {
  colors: pvColors,
  border,
  grid,
  shadow,
  spacing,
  typography: typography.typography,
};

export * from "./tokens/colors";
export * from "./tokens/border";
export * from "./tokens/grid";
export * from "./tokens/shadow";
export * from "./tokens/spacing";
export * from "./tokens/typography";
